<!--
Program: Pagination
Author: SDL
Description: Pagination Common Component
-->
<template>
  <div class="fx_pagination">
    <ul>
      <li class="page_first" :class="[{ disabled: currentPage === 1 }]" @click.prevent="changePage(prevPage(currentPage))"></li>
      <li class="page_prev" :class="[{ disabled: currentPage <= 1 }]" @click.prevent="changePage(1 >= currentPage - 1 ? 1 : currentPage - 1)"></li>
      <li v-for="num in pages" :class="[{ active: num === currentPage }]" :key="num" @click.prevent="changePage(num)">
        {{ num }}
      </li>
      <li class="page_next" :class="[{ disabled: currentPage === lastPage || lastPage === 0 }]" @click.prevent="changePage(currentPage > lastPage - 1 ? lastPage : currentPage + 1)"></li>
      <li class="page_last" :class="[{ disabled: currentPage === lastPage || lastPage === 0 }]" @click.prevent="changePage(nextPage(currentPage))"></li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    currentPage: {
      required: false,
      type: Number,
    },
    totalRows: {
      required: false,
      type: Number,
    },
    perPage: {
      required: false,
      type: Number,
    },
    limit: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      curPage: 1,
    };
  },
  created() {
    this.curPage = this.currentPage;
  },
  computed: {
    /**
     * param:
     * return:
     * exception:
     * Description : last page calculation
     */
    lastPage() {
      const total = this.totalRows / this.perPage;
      if (total < 1) return 1;

      if (total % 1 !== 0) return parseInt(total + 1, 10);

      return total;
    },
    /**
     * param:
     * return:
     * exception:
     * Description : page calculation to be shown
     */
    pages() {
      let from = Math.floor((this.currentPage - 1) / this.limit) * this.limit + 1;
      let to = from + this.limit-1;
      if (to >= this.lastPage) to = this.lastPage;
      const arr = [];
      while (from <= to) {
        arr.push(from);
        from += 1;
      }
      if (this.totalRows === null) {
        arr.splice(0);
        arr.push(1);
      }
      return arr;
    },
  },
  methods: {
    /**
     * param:
     * return:
     * exception:
     * Description : Parents' change event call
     */
    changePage(page) {
      this.$emit('change', page);
    },
    nextPage(page) {
      if (((Math.ceil(page/ this.limit)) * this.limit) + 1 >= this.lastPage) return this.lastPage;
      return ((Math.ceil(page/ this.limit)) * this.limit) + 1;
    },
    prevPage(page) {
      if (((Math.ceil(page / this.limit) - 2) * this.limit) + 1 <= 1) return 1;
      return ((Math.ceil(page / this.limit) - 2) * this.limit) + 1;
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/common/control/pagination/Pagination.vue